<template>
	<div class="tw-flex tw--mx-3">
		<div class="px-3 tw-w-3/5">
			<p-card class="tw-p-2">
				<span :style="`color:${$appColors.info}`">
					<b class="">Seleccione la plataforma a configurar</b>
				</span>
				<div class="tw-flex tw-flex-wrap tw--mx-2 tw-my-3">
					<div
						class="tw-w-1/2 lg:tw-w-1/3 2xl:tw-w-1/5 tw-px-2 tw-mb-4"
						v-for="(platform, index) in platforms.data"
						:key="index">
						<square-box
							:logo="platform.urlLogo"
							:checked="verifyRegister(platform)"
							:focused="selectedPlatform.code === platform.code"
							:assigned="validAssinged(platform)"
							@handle-click="handlePlatformSelected($event, platform)">
						</square-box>
					</div>
				</div>
			</p-card>
		</div>
		<div class="px-3 tw-w-2/5">
			<model-description
				:title="'CONFIGURACIÓN DE PLATAFORMAS INTEGRADAS'"
				:subtitle="subtitle">
				<div v-if="!configIntegration" class="tw-my-4 tw-flex tw-flex-col tw-text-center tw-justify-center tw-items-center" slot="content">
					<p class="tw-mb-3 tw-text-center">
						En esta secciónm podrá configurar los accesos para las plataformas con las que se integra su cuenta.
					</p>
					<p class="tw-mb-12 tw-text-left">
						1. Seleccione la plataforma.<br>
						2. Ingrese credenciales.<br>
						3. Presione guardar.<br>
					</p>
				</div>
				<div v-else class="tw-my-4 tw-flex tw-flex-col tw-text-center tw-justify-center tw-items-center" slot="content">
					<div class="tw-w-full" v-if="!showForm">
						<div class="tw-flex tw-flex-col tw-mb-12">
							<label :style="`color:${$appColors.info}; font-weight: bold;`">Usuario:
								<input
									class="form-applicant-input"
									type="text"
									v-model="model.user">
							</label>
							<label :style="`color:${$appColors.info}; font-weight: bold;`">Password:
								<div class="tw-relative">
									<input
										class="form-applicant-input"
										:type="!showPassword ? 'password' : 'text'"
										v-model="model.password">
									<v-icon size="16" color="primary" class="view-pass" @click="showPassword = !showPassword">{{!showPassword ? 'visibility' : 'visibility_off'}}</v-icon>
								</div>
							</label>
							<label :style="`color:${$appColors.info}; font-weight: bold;`">Url de la plataforma:
								<input
									class="form-applicant-input"
									placeholder="https://empresa.ec.computrabajo.com/Company/"
									type="text"
									v-model="model.login_url">
							</label>
						</div>
						<!--<p-button
							v-if="!flagEdit"
							type="primary"
							@click="editForm">Editar</p-button>-->
						<p-button
							type="secondary"
							:disabled="this.model.user === null || this.model.password === null || this.model.login_url === null"
							@click="saveConfigAccess">Guardar</p-button>
					</div>
					<div v-else>
						<p-button type="primary" @click="viewDataRegister">Ver información</p-button>
					</div>
				</div>
			</model-description>
		</div>
		<v-dialog v-model="showAlertNoAssigned" persistent width="400">
			<p-card class="tw-flex tw-flex-col tw-m-0">
				<div class="tw-flex tw-flex-col tw-text-center" :style="`color:${$appColors.info}; font-weight: bold;`">
					<p>No tiene asignada esta plataforma...</p>
					<p>Contactese con soporte.</p>
				</div>
				<p-horizontal-divider></p-horizontal-divider>
				<div class="tw-flex tw-justify-center tw-items-center">
					<p-button type="primary" @click="showAlertNoAssigned = false">Aceptar</p-button>
				</div>
			</p-card>
		</v-dialog>
	</div>
</template>

<script>
	import PCard from '@/modules/shared/components/ui/Card/p-card';
	import PButton from '@/modules/shared/components/ui/p-button';
	import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
	import modelDescription from '@/modules/job-profile/components/content/model-description';
	import squareBox from '@/components/configuration/external-integrations/simple-square-box';
	import helper from '@/shared/helper';
	import { pathOr } from 'ramda';
	import { mapState } from 'vuex';

	export default {
		name: 'page-external-integrations',
		components: {
			PCard,
			PButton,
			PHorizontalDivider,
			modelDescription,
			squareBox,
		},
		created() {
			this.$store.dispatch('jobEvaluation/loadPlatforms');
			this.loadCompanyDetail();
		},
		data() {
			return {
				configIntegration: false,
				model: {
					user: null,
					password: null,
					login_url: null,
				},
				selectedPlatform: {},
				companyData: {},
				showForm: false,
				showPassword: false,
				assignPlatforms: [],
				showAlertNoAssigned: false,
				flagEdit: false,
			};
		},
		methods: {
			editForm() {
				this.flagEdit = true;
			},
			handlePlatformSelected(type, platform) {
				if (type === 'assigned') {
					this.selectedPlatform = platform;
					this.configIntegration = true;
					this.showForm = this.verifyDataToPlatform();
				} else {
					this.showAlertNoAssigned = true;
				}
			},
			formatBody(newIntegration) {
				if (this.companyData.integrations === null) {
					this.companyData.integrations = {};
				}
				if (Object.prototype.hasOwnProperty
					.call(this.companyData.integrations, this.selectedPlatform.code)) {
					this.companyData.integrations[this.selectedPlatform.code] = {
						...this.companyData.integrations[this.selectedPlatform.code],
						...newIntegration,
					};
				} else {
					this.companyData.integrations[this.selectedPlatform.code] = newIntegration;
				}
				return this.companyData.integrations;
			},
			async saveConfigAccess() {
				try {
					let response;
					const platformsSelected = this.platforms.data
						.find(p => p.code === this.selectedPlatform.code);
					const bodyScraper = {
						name: platformsSelected.name,
						login_url: this.model.login_url,
						user: this.model.user,
						password: this.model.password,
					};
					if (!this.verifyDataToPlatform()) {
						({ data: response } = await this.$httpScraper.post('credential', bodyScraper));
					} else {
						const id = this.companyData.integrations[this.selectedPlatform.code].id;
						await this.$httpScraper.patch(`credential/${id}`, bodyScraper);
						({ data: response } = await this.$httpScraper.get(`credential/${id}`));
					}
					const body = {
						integrations: this.formatBody(response.data),
					};
					await this.$httpPraktiko.patch(`/companies/${this.companyData.id}`, body);
					this.configIntegration = false;
					this.model = {
						user: null,
						password: null,
						login_url: null,
					};
					this.loadCompanyDetail();
				} catch (error) {
					this.showGenericError();
				}
				this.selectedPlatform = {};
			},
			async loadCompanyDetail() {
				const userInfo = helper.getLocalData('praktiko-user');
				const { company } = userInfo;
				try {
					const { data: response } = await this.$httpPraktiko.get(`/companies/detail/${company.id}`);
					this.companyData = response;
					this.assignPlatforms = response.assignedPlatforms;
				} catch (error) {
					this.showGenericError();
				}
			},
			verifyRegister(platform) {
				return this.companyData.integrations &&
					Object.prototype.hasOwnProperty.call(this.companyData.integrations, platform.code);
			},
			verifyDataToPlatform() {
				if (this.selectedPlatform) {
					return this.companyData.integrations && Object.prototype.hasOwnProperty
						.call(this.companyData.integrations, this.selectedPlatform.code);
				}
				return false;
			},
			viewDataRegister() {
				this.showForm = false;
				const dataIntegration = this.companyData.integrations[this.selectedPlatform.code];
				this.model = {
					user: dataIntegration.user,
					password: dataIntegration.password,
					login_url: dataIntegration.login_url,
				};
			},
			validAssinged(platform) {
				return this.assignPlatforms.some(item => item.code === platform.code);
			},
		},
		computed: {
			subtitle() {
				return this.configIntegration ? `INGRESE LOS ACCESOS DE ${this.selectedPlatform.name}` : 'INSTRUCCIONES';
			},
			...mapState('jobEvaluation', {
				platforms: pathOr([], ['supplies', 'generalData', 'platforms']),
			}),
		},
		watch: {
			selectedPlatform: {
				handler(newVal, oldVal) {
					if (newVal.code !== oldVal.code) {
						this.model = {
							user: null,
							password: null,
							login_url: null,
						};
					}
				},
			},
		},
	};
</script>

<style lang="scss" scoped>
.form-applicant {
	width: 100%;
	&-input {
		background: map-get($colors, white);
		border: 1px solid map-get($colors, gray-slider);
		border-radius: 4px;
		display: block;
		outline: none;
		color: map-get($colors, gray-sidebar);
		padding: 5px 20px;
		width: 100%;

		&::placeholder {
			color: map-get($colors, placeholder);
		}
	}
}
.view-pass {
	position: absolute;
	top: 9.5px;
	right: 5px;
}
</style>


// WEBPACK FOOTER //
// src/pages/configuration/page-external-integrations.vue